import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/store/store';
const requireLocales = require.context('@/locales', false, /\.js$/);

Vue.use(VueI18n);

Vue.filter('translate', (key) => vuei18n.t(key));

const messages = {};

requireLocales.keys().forEach((locale) => {
  messages[locale.replace(/(\.\/|\.js)/g, '')] = {
    ...requireLocales(locale)?.default,
  };
});

const dateTimeFormats = {
  'en-US': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  'en-CA': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    time: {
      hour: 'numeric',
      minute: 'numeric',
    },
    longDate: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },
    shortDate: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
  },
};

const vuei18n = new VueI18n({
  locale: store.state.locale.replace('_', '-') || process.env.VUE_APP_LOCALE.replace('_', '-') || 'en-US',
  fallbackLocale: process.env.VUE_APP_FALLBACK_LOCALE || 'en-US',
  dateTimeFormats,
  numberFormats: {
    'en-CA': {
      currency: {
        style: 'currency',
        currency: 'CAD',
      },
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
    'en-US': {
      currency: {
        style: 'currency',
        currency: 'USD',
      },
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
  messages,
  silentTranslationWarn: true,
});

export default vuei18n;
